// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__36qwf","footer":"ModalInfo_footer__2axly"};